import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type Month = {
  id: string;
  date: Date;
  currentValue: number;
  originalValue: number;
  isAvailable?: boolean;
};

export interface MonthState {
  daysInMonth?: Month[];
  isLoading?: boolean;
}

const initialState: MonthState = {
  daysInMonth: [],
  isLoading: false,
};

const monthSlice = createSlice({
  name: "month",
  initialState,
  reducers: {
    setDays: (state, action: PayloadAction<Month[]>) => {
      state.daysInMonth = Array.from(
        new Map(
          [...(state.daysInMonth || []), ...action.payload].map((item) => [
            item.date,
            item,
          ])
        ).values()
      );
    },

    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

export const { setDays, setLoading } = monthSlice.actions;
export default monthSlice.reducer;
